import { Box, RadioGroup, Typography } from '@mui/material';
import styled from 'styled-components';

interface SurveyResponseProps {
  $columnStyle?: boolean;
  $displayStyle?: string;
  $isHeight?: boolean;
  $isPopup?: boolean;
}

interface HeightContainerProps {
  $isHeight?: boolean;
}

interface MCContainerProps {
  $isRow?: boolean;
}

export const QuestionnaireContainerStyled = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#ffffff',
  boxShadow: '0px 1px 10px 0px #0000003D',
  padding: '40px 36px',
  '@media screen and (max-width: 743px)': {
    padding: '24px 16px',
    flexDirection: 'column',
    height: 'auto',
  },
});

export const FamilyMemberContainerStyled = styled(Box)({
  display: 'block',
  paddingTop: '2rem',
  marginBottom: '-1rem',
});

export const QuestionnaireFormContainerStyled = styled(Box)({
  marginTop: '-4rem',
  width: '100%',
});

export const QuestionContainerStyled = styled('fieldset')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
});

export const SurveyResponseContainerStyled = styled(Box)<SurveyResponseProps>(
  ({ theme, $columnStyle, $displayStyle, $isHeight, $isPopup }) => ({
    display: $displayStyle,
    width: '100%',
    maxWidth: '100%',
    flexDirection: $columnStyle ? 'column' : 'row',
    height: 'auto',
    label: {
      marginTop: '12px',
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: $isHeight ? '50%' : '100%',
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: $isHeight ? ($isPopup ? '50%' : '30%') : '100%',
    },
  })
);

export const HeightContainerDependentStyled = styled(Box)<HeightContainerProps>(
  ({ $isHeight }) => ({
    display: $isHeight ? 'flex' : 'inherit',
  })
);

export const MCQuestionContainerDependentStyled = styled(Box)<MCContainerProps>(
  ({ $isRow }) => ({
    display: 'flex',
    flexDirection: $isRow ? 'row' : 'inherit',
  })
);

export const QuestionTextStyled = styled('legend')({
  alignSelf: 'flex-start',
});

export const HeightSurveyContainerStyled = styled(Box)({
  display: 'flex',
});

export const RadioGroupStyled = styled(RadioGroup)({
  flexDirection: 'inherit',
});

export const RequiredQuestionStyled = styled(Typography)({
  color: 'var(--wcag-red)',
});
